export default __webpack_public_path__ + "static/Supreme-Regular-2ec9d0176d965ff507821cc4094815ac.woff";